import { State } from './../../../../pages/activities/calendar/types';
export enum FeedbackStatusEnum {
  NEW = 'initial',
  INTERVIEW = 'interview',
  INVITATION = 'invitation',
  REFUSAL = 'employer_refusal',
  CANDIDATE_REFUSAL = 'candidate_refusal',
}

export type ParseVacanciesType = {
  id: string;
  vacancy: string;
  salary: string;
  organization: string;
  organizationAddress: string;
};

export interface VacancyBase {
  id: string;
  site: string;
  state: string;
  email: string;
  duties: string;
  salary: string;
  is_ovz: boolean;
  created: string;
  end_work: string;
  languages: string;
  partner_logo: string;
  partner_id: string;
  begin_work: string;
  place_type: string;
  experience: string;
  state_name: string;
  description: string;
  update_type: string;
  is_deleted: boolean;
  vacancy_name: string;
  vacancy_desc: string;
  requirements: string;
  partner_name: string;
  is_agreement: boolean;
  contact_person: string;
  visibility_type: string;
  diseases_name: string[];
  place_type_name: string;
  is_other_cities: boolean;
  update_type_name: string;
  driver_license_id: string;
  employment_type_id: string;
  work_place_address: string;
  education_level_id: string;
  is_addresses_match: string;
  competences_name: string[];
  professions_name: string[];
  phone_number: Array<string>;
  driver_license_name: string;
  organization_address: string;
  employment_type_name: string;
  visibility_type_name: string;
  education_level_name: string;
  publish_date: string;
  user_can_create_order: boolean;
  video: string;
}

export interface Vacancies extends VacancyBase {
  salary: string;
  vacancy_name: string;
  organization: string;
  organization_address: string;
}

export interface VacancyMain {
  duties: string;
  endWork: string;
  beginWork: string;
  languages: string;
  experience: string;
  description: string;
  isAgreement: string;
  requirements: string;
  placeTypeName: string;
  isOtherCities: string;
  competencesName: string;
  professionsName: string;
  workPlaceAddress: string;
  driverLicenseName: string;
  employmentTypeName: string;
  educationLevelName: string;
  publish_date: string;
  video: string;
}

export interface VacancySidebar {
  site: string;
  email: string;
  partnerId: string;
  phoneNumber: string;
  description: string;
  partnerName: string;
  partnerLogo: string;
  contactPerson: string;
  organizationAddress: string;
}

export interface VacancyFeedback {
  id: string;
  state: string;
  user_id: string;
  vacancy_id: string;
  state_name: string;
  date_created: string;
  date_updated: string;
  vacancy_name: string;
  partner_logo: string;
  user_can_cancel: boolean;
  date_state: string;
  partner_name: string;

}

export interface Status {
  sort: number;
  color?: string;
  message: string;
  refusal?: boolean;
}

export interface ParsedState extends Status {
  stateName: string;
}

export interface ParsedVacancyFeedback {
  id: string;
  vacancyId: string;
  state: ParsedState;
  vacancyName: string;
  partnerLogo: string;
  dateСreated: string;
  userCanCancel: boolean;

}

export interface ParsedVacancy {
  id: string;
  name: string;
  main: VacancyMain;
  sidebar: VacancySidebar;
  user_can_create_order: boolean;
}

export interface GetVacancies {
  data: VacanciesType;
}

export interface GetVacancy {
  data: VacancyBase;
}

export type VacanciesType = Array<Vacancies>;
export type VacanciesFeedbackType = Array<VacancyFeedback>;
export type MapedVacanciesType = Array<ParseVacanciesType>;
export type ParsedVacanciesFeedbackType = Array<ParsedVacancyFeedback>;



// WEBPACK FOOTER //
// ./src/services/api/vacancies/utils/types.ts